import MediaHelper from '../helpers/MediaHelper';
import {disablePageScroll, enablePageScroll} from "scroll-lock";

const initAddedToCart = () => {

	// Click Listener for close event.
	document.addEventListener( 'click', ( ev ) => {

		if ( ev.target && ev.target.closest( '.en_js_close_addedtocart' ) ) {
			ev.preventDefault();

			const moduleEl = ev.target.closest( '.mdl_addedtocart' );
			if ( ! moduleEl ) {
				return;
			}

			// Get necessary inner container Els.
			const containerEl = moduleEl.querySelector( '.mdl_addedtocart__container' );

			if ( ! moduleEl.classList.contains( 'mdl_addedtocart--quickview' ) && MediaHelper.matches( null, 'desktop' ) ) {
				enablePageScroll( containerEl );
			}

			moduleEl.classList.remove( 'is-visible' );
			setTimeout( function() {
				moduleEl.classList.remove( 'is-active' );
			}, 250 );
		}
	} );

	MediaHelper.watch( function( mq ) {
		const moduleEl = document.querySelector( '.mdl_addedtocart' );
		if ( ! moduleEl ) {
			return;
		}

		// Get necessary inner container Els.
		const containerEl = moduleEl.querySelector( '.mdl_addedtocart__container' );

		if ( moduleEl.classList.contains( 'is-active' ) ) {
			if ( mq.matches ) {
				enablePageScroll( containerEl );
			} else {
				disablePageScroll( containerEl );
			}
		}
	}, 'desktop' );
}

export {
	initAddedToCart
};
